import { v as bvVar } from '../../bv/vars';

export default () => bvVar('locale');
